(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("dyna-interfaces"), require("eventemitter3"), require("isomorphic-fetch"), require("jsonwebtoken"));
	else if(typeof define === 'function' && define.amd)
		define("dyna-auth-rtt", ["dyna-interfaces", "eventemitter3", "isomorphic-fetch", "jsonwebtoken"], factory);
	else if(typeof exports === 'object')
		exports["dyna-auth-rtt"] = factory(require("dyna-interfaces"), require("eventemitter3"), require("isomorphic-fetch"), require("jsonwebtoken"));
	else
		root["dyna-auth-rtt"] = factory(root["dyna-interfaces"], root["eventemitter3"], root["isomorphic-fetch"], root["jsonwebtoken"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_6__, __WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_8__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 9);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("dyna-interfaces");

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DynaAuthRTTClient_1 = __webpack_require__(2);
exports.DynaAuthRTTClient = DynaAuthRTTClient_1.DynaAuthRTTClient;
var DynaAuthRTTServer_1 = __webpack_require__(3);
exports.DynaAuthRTTServer = DynaAuthRTTServer_1.DynaAuthRTTServer;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var eventemitter3_1 = __webpack_require__(6);
var request_1 = __webpack_require__(5);
var DynaAuthRTTClient = /** @class */ (function (_super) {
    __extends(DynaAuthRTTClient, _super);
    function DynaAuthRTTClient() {
        var _this = _super.call(this) || this;
        _this.events = {
            restartAuthentication: 'restartAuthentication',
            updateUserState: 'updateUserState',
        };
        _this.ACCESS_TOKEN_ITEM_NAME = 'ACCESS_TOKEN_ITEM_NAME';
        _this.REFRESH_TOKEN_ITEM_NAME = 'REFRESH_TOKEN_ITEM_NAME';
        _this.request = _this.request.bind(_this);
        return _this;
    }
    Object.defineProperty(DynaAuthRTTClient.prototype, "accessToken", {
        get: function () {
            return localStorage.getItem(this.ACCESS_TOKEN_ITEM_NAME) || '';
        },
        set: function (token) {
            if (token)
                localStorage.setItem(this.ACCESS_TOKEN_ITEM_NAME, token);
            else
                localStorage.removeItem(this.ACCESS_TOKEN_ITEM_NAME);
        },
        enumerable: true,
        configurable: true
    });
    ;
    ;
    Object.defineProperty(DynaAuthRTTClient.prototype, "refreshToken", {
        get: function () {
            return localStorage.getItem(this.REFRESH_TOKEN_ITEM_NAME) || '';
        },
        set: function (token) {
            if (token)
                localStorage.setItem(this.REFRESH_TOKEN_ITEM_NAME, token);
            else
                localStorage.removeItem(this.REFRESH_TOKEN_ITEM_NAME);
        },
        enumerable: true,
        configurable: true
    });
    ;
    ;
    Object.defineProperty(DynaAuthRTTClient.prototype, "hasToken", {
        get: function () {
            return !!this.accessToken;
        },
        enumerable: true,
        configurable: true
    });
    DynaAuthRTTClient.prototype.setTokens = function (accessToken, refreshToken) {
        this.accessToken = accessToken;
        this.refreshToken = refreshToken;
    };
    DynaAuthRTTClient.prototype.removeToken = function () {
        this.accessToken = '';
        this.refreshToken = '';
    };
    DynaAuthRTTClient.prototype.request = function (settings) {
        return this._request(settings);
    };
    DynaAuthRTTClient.prototype._request = function (settings, applyRefreshToken) {
        var _this = this;
        if (applyRefreshToken === void 0) { applyRefreshToken = false; }
        return new Promise(function (resolve, reject) {
            var url = settings.url, method = settings.method, requestData = settings.requestData, clearToken = settings.clearToken;
            if (clearToken)
                _this.removeToken();
            request_1.request({
                url: url,
                method: method,
                accessToken: !applyRefreshToken ? _this.accessToken : undefined,
                refreshToken: applyRefreshToken ? _this.refreshToken : undefined,
                requestData: requestData,
            })
                .then(function (response) {
                if (response.auth.accessToken)
                    _this.accessToken = response.auth.accessToken;
                if (response.auth.refreshToken)
                    _this.refreshToken = response.auth.refreshToken;
                resolve(response.data);
                if (response.auth.userState)
                    _this.emit(_this.events.updateUserState, response.auth.userState);
            })
                .catch(function (error) {
                if (error.networkStatus === 401 && error && error.data && error.data.auth && error.data.auth.provideRefreshToken) {
                    _this._request(settings, true)
                        .then(resolve)
                        .catch(reject);
                }
                else if (error.networkStatus === 401 && error && error.data && error.data.auth && error.data.auth.restartAuthentication) {
                    reject(error);
                    setTimeout(function () { return _this.emit(_this.events.restartAuthentication); }, 0); // trigger it on next tick in order the reject to be consumed
                }
                else {
                    reject(error);
                }
            });
        });
    };
    return DynaAuthRTTClient;
}(eventemitter3_1.EventEmitter));
exports.DynaAuthRTTClient = DynaAuthRTTClient;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var dyna_interfaces_1 = __webpack_require__(0);
var jwt_1 = __webpack_require__(4);
var daysInSecs = function (days) { return days * 24 * 60 * 60; };
var DynaAuthRTTServer = /** @class */ (function () {
    function DynaAuthRTTServer(config) {
        this.accessTokenSecret = '0';
        this.refreshTokenSecret = '0';
        this.config = config;
        if (!this.config.onUserStateUpdate)
            this.config.onUserStateUpdate = function (userState) { return Promise.resolve(userState); };
        this.respond = this.respond.bind(this);
        this.updateAccessToken = this.updateAccessToken.bind(this);
        this.updateRefreshToken = this.updateRefreshToken.bind(this);
    }
    Object.defineProperty(DynaAuthRTTServer.prototype, "emptyUserState", {
        get: function () {
            return {
                userId: null,
                roles: '',
            };
        },
        enumerable: true,
        configurable: true
    });
    DynaAuthRTTServer.prototype.start = function () {
        var _this = this;
        return Promise.resolve()
            .then(function () { return _this.config.loadAccessTokenSecret(); })
            .then(function (secret) { return _this.accessTokenSecret = secret; })
            .then(function () { return _this.config.loadRefreshTokenSecret(); })
            .then(function (secret) { return _this.refreshTokenSecret = secret; })
            .then(function () { return undefined; })
            .catch(function (error) {
            console.error('DynaAuthRTTServer: cannot load access/refreshTokenSecret', { error: error });
            return Promise.reject(error);
        });
    };
    DynaAuthRTTServer.prototype.changeAccessTokenSecret = function (secret) {
        this.accessTokenSecret = secret;
        return this.config.saveAccessTokenSecret(secret);
    };
    DynaAuthRTTServer.prototype.changeRefeshTokenSecret = function (secret) {
        this.refreshTokenSecret = secret;
        return this.config.saveAccessTokenSecret(secret);
    };
    DynaAuthRTTServer.prototype.registerToExpress = function (app) {
        app.use(this.middlewareCreateUserState.bind(this));
        app.get('/api/dartt/refreshToken', this.serviceGetNewAccessTokenByRefreshToken.bind(this));
    };
    DynaAuthRTTServer.prototype.updateUserState = function (res, userState, exportItAnyway) {
        if (exportItAnyway === void 0) { exportItAnyway = false; }
        var auth = res.locals.auth;
        auth.exportUserState =
            (exportItAnyway)
                || (auth.userState.userId !== userState.userId || auth.userState.roles !== userState.roles);
        auth.userState = userState;
    };
    DynaAuthRTTServer.prototype.updateAccessToken = function (res) {
        var auth = res.locals.auth;
        auth.newAccessToken = jwt_1.signToken(auth.userState, this.accessTokenSecret, this.config.accessTokenExpiresInSec);
    };
    DynaAuthRTTServer.prototype.updateRefreshToken = function (res) {
        var auth = res.locals.auth;
        auth.newRefreshToken = jwt_1.signToken(auth.userState, this.refreshTokenSecret, daysInSecs(this.config.refreshTokenExpiresInDays));
    };
    DynaAuthRTTServer.prototype.middlewareCreateUserState = function (req, res, next) {
        var _this = this;
        var authServices = {
            userState: this.emptyUserState,
            provideRefreshToken: false,
            restartAuthentication: false,
            exportUserState: false,
            newAccessToken: null,
            newRefreshToken: null,
        };
        res.locals.auth = authServices;
        this.respond({
            req: req, res: res,
            generalError: {
                code: 1711051835,
                section: 'DynaAuthRTTServer/middlewareCreateUserState',
            },
            run: function (auth, respondOk, respondError) {
                // check the origin
                if (_this.config.allowOrigins && _this.config.allowOrigins.length) {
                    var validOrigin = _this.config.allowOrigins.reduce(function (acc, scanOrigin) {
                        if (acc)
                            return acc;
                        return scanOrigin.indexOf(req.headers.origin) === 0;
                    }, false);
                    if (!validOrigin) {
                        respondError(401, { code: 600507, data: { origin: req.headers.origin } });
                        return;
                    }
                }
                // get the tokes from the bearer
                var clientAccessToken;
                var clientRefreshToken;
                var headerAuthorization = (req.headers.authorization || '').split(' ');
                if (headerAuthorization[0] === 'Bearer') {
                    var tokens = void 0;
                    try {
                        tokens = JSON.parse(headerAuthorization[1]);
                    }
                    catch (error) {
                        respondError(400, { message: 'tokens in wrong format' });
                        return;
                    }
                    clientAccessToken = tokens.at;
                    clientRefreshToken = tokens.rt;
                }
                // clientAccessToken is provided only, a typical request with token
                if (clientAccessToken) {
                    var verifyResults = jwt_1.verifyToken(clientAccessToken, _this.accessTokenSecret);
                    if (verifyResults.valid) {
                        // token is valid... use the saved userState
                        authServices.userState = verifyResults.data;
                    }
                    else {
                        // the token is invalid (because is expired or because cannot be decoded)
                        authServices.provideRefreshToken = true;
                        respondError(401, { message: 'access denied' });
                        return;
                    }
                }
                // refresh token provided, so, new accessToken is requested
                if (clientRefreshToken) {
                    var verifyResults = jwt_1.verifyToken(clientRefreshToken, _this.refreshTokenSecret);
                    if (verifyResults.valid) {
                        // token is valid... use the saved userState
                        authServices.userState = verifyResults.data;
                        _this.updateAccessToken(res);
                        _this.updateRefreshToken(res);
                    }
                    else {
                        // the token is invalid (because is expired or because cannot be decoded)
                        authServices.restartAuthentication = true;
                        respondError(401, { message: 'access denied' });
                        return;
                    }
                }
                // final task... ask the application about this userState
                _this.config.onUserStateUpdate(authServices.userState)
                    .then(function (userState) {
                    _this.updateUserState(res, userState);
                    // if tokens have been applied, refresh them with the new userState
                    if (authServices.newAccessToken)
                        _this.updateAccessToken(res);
                    if (authServices.newRefreshToken)
                        _this.updateRefreshToken(res);
                    next();
                })
                    .catch(function (error) {
                    console.error('DynaAuthRTTServer: 1601121210 onUserStateUpdate failed:', error);
                });
            }
        });
    };
    DynaAuthRTTServer.prototype.serviceGetNewAccessTokenByRefreshToken = function (req, res, next) {
        var _this = this;
        this.respond({
            req: req, res: res,
            generalError: {
                code: 1711042021,
                section: 'DynaAuthRTTServer/dartt',
            },
            run: function (auth, respondOk, respondError) {
                var refreshToken = req.query.rt;
                if (!refreshToken) {
                    respondError(400, {
                        message: 'invalid data',
                    });
                    return;
                }
                var verify = jwt_1.verifyToken(refreshToken, _this.refreshTokenSecret);
                if (verify.valid) {
                    auth.userState = verify.data;
                    _this.config.onUserStateUpdate(auth.userState)
                        .then(function (userState) {
                        _this.updateUserState(res, userState, true);
                        _this.updateAccessToken(res);
                        _this.updateRefreshToken(res);
                        respondOk();
                    });
                }
                else {
                    auth.restartAuthentication = true;
                    respondError(401, {});
                }
            }
        });
    };
    DynaAuthRTTServer.prototype.createNewAuthForClient = function (userState, accessTokenExpiresInSec, refreshTokenExpiresInDays) {
        return {
            userState: userState,
            accessToken: jwt_1.signToken(userState, this.accessTokenSecret, accessTokenExpiresInSec || this.config.accessTokenExpiresInSec),
            refreshToken: jwt_1.signToken(userState, this.refreshTokenSecret, daysInSecs(refreshTokenExpiresInDays || this.config.refreshTokenExpiresInDays)),
        };
    };
    /*
  Respond is a run box to process your response.
  The middlawareAuthTokensValidation validates the client's given token and updates the res.locals._auth.userState.
  You may modify your userState: IUserState as you want at res.locals._auth.userState.
  The respond will create and return a new token, IF the res.locals._auth.userState exists.

    respond({
        req, res,
        generalError: {
            code: 19101322142,
            section: 'section/place',
        },
        // validRoles: [],
        run: (auth: IDynaAuthInterfaceForServices, respondOk: (data?: any, status?: number) => void, respondError: (status: number, error?: IError) => void) => {
            const userId: string = requestData.userId;

        }
    });

    * */
    DynaAuthRTTServer.prototype.respond = function (params) {
        var req = params.req, res = params.res, requiredQueries = params.requiredQueries, requiredParams = params.requiredParams, requiredBodyProps = params.requiredBodyProps, validRoles = params.validRoles, generalError = params.generalError, run = params.run;
        var authServices = res.locals.auth;
        var validRole = true;
        if (authServices.userState && validRoles && validRoles.length) {
            validRole = false;
            var userRoles_1 = authServices.userState.roles.split(',').filter(function (r) { return !!r; });
            validRoles.forEach(function (role) {
                if (!validRole)
                    validRole = userRoles_1.indexOf(role) > -1;
            });
        }
        var getAuth = function () {
            var authClient = {};
            if (authServices.exportUserState)
                authClient.userState = authServices.userState;
            authClient.provideRefreshToken = authServices.provideRefreshToken || undefined;
            authClient.restartAuthentication = authServices.restartAuthentication || undefined;
            if (authServices.newAccessToken)
                authClient.accessToken = authServices.newAccessToken;
            if (authServices.newRefreshToken)
                authClient.refreshToken = authServices.newRefreshToken;
            return authClient;
        };
        if (!validRole) {
            res.status(401);
            res.json({
                auth: getAuth(),
                error: __assign({}, generalError, { networkStatus: 401, code: 1710211710, errorType: dyna_interfaces_1.EErrorType.USER, message: 'access denied' })
            });
            return;
        }
        if (requiredQueries) {
            var valid_1 = true;
            requiredQueries.forEach(function (queryName) { return valid_1 = valid_1 && (typeof req.query[queryName] !== 'undefined'); });
            if (!valid_1) {
                res.status(400);
                res.json({
                    auth: getAuth(),
                    error: __assign({}, generalError, { networkStatus: 400, code: 1516651685793, errorType: dyna_interfaces_1.EErrorType.USER, message: "Bad request, a query is missing" })
                });
                return;
            }
        }
        if (requiredParams) {
            var valid_2 = true;
            requiredParams.forEach(function (paramName) { return valid_2 = valid_2 && (typeof req.params[paramName] !== 'undefined'); });
            if (!valid_2) {
                res.status(400);
                res.json({
                    auth: getAuth(),
                    error: __assign({}, generalError, { networkStatus: 400, code: 1516651877510, errorType: dyna_interfaces_1.EErrorType.USER, message: "Bad request, a param is missing" })
                });
                return;
            }
        }
        if (requiredBodyProps) {
            var valid_3 = true;
            requiredBodyProps.forEach(function (bodyPropName) { return valid_3 = valid_3 && (typeof req.body[bodyPropName] !== 'undefined'); });
            if (!valid_3) {
                res.status(400);
                res.json({
                    auth: getAuth(),
                    error: __assign({}, generalError, { networkStatus: 400, code: 1516651949446, errorType: dyna_interfaces_1.EErrorType.USER, message: "Bad request, a body prop is missing" })
                });
                return;
            }
        }
        // RUN!
        try {
            run(authServices, 
            /* respondOk */ function (data, status) {
                if (status === void 0) { status = 200; }
                res.status(status);
                res.json({
                    data: data,
                    auth: getAuth(),
                });
            }, 
            /* respondError */ function (status, error) {
                if (error === void 0) { error = {}; }
                var outputError = __assign({}, generalError, error);
                if (!outputError.message && outputError.error && outputError.error.message)
                    outputError.message = "Nested error message: " + outputError.error.message;
                if (outputError.networkStatus)
                    status = outputError.networkStatus;
                if (status === 500)
                    console.error('DynaAuthRTTServer: respondError: ', status, error);
                res.status(status);
                res.json({
                    auth: getAuth(),
                    error: outputError,
                });
            });
        }
        catch (error) {
            res.status(500);
            res.json({
                error: __assign({}, generalError, { errorType: dyna_interfaces_1.EErrorType.APP, message: 'general error', error: error.message })
            });
        }
    };
    ;
    return DynaAuthRTTServer;
}());
exports.DynaAuthRTTServer = DynaAuthRTTServer;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var jsonwebtoken_1 = __webpack_require__(8);
exports.signToken = function (data, secret, expiresInSecs) {
    var options = {};
    if (expiresInSecs)
        options.expiresIn = Math.round(expiresInSecs);
    return jsonwebtoken_1.sign({ data: data }, secret, options);
};
exports.verifyToken = function (token, secret) {
    try {
        var decoded = token && jsonwebtoken_1.verify(token, secret) || null;
        var data = decoded && decoded.data || null;
        return {
            data: data,
            valid: !!decoded,
            error: null,
        };
    }
    catch (error) {
        return {
            data: null,
            valid: false,
            error: error,
        };
    }
};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* Den note: request is a pure network request, for json object of TData (generic) form
             it is completely independent and runs everywhere.
* */
var fetch = __webpack_require__(7);
var dyna_interfaces_1 = __webpack_require__(0);
exports.request = function (settings) {
    var networkStatus = -1;
    var requestBody;
    var url = settings.url, method = settings.method, requestData = settings.requestData;
    if (requestData) {
        var bodyStringify = jsonStringify(requestData);
        if (bodyStringify.error) {
            return Promise.reject({
                code: 1710131735,
                section: 'fetchPost/prepareRequestBody',
                message: 'error on stringify',
                data: { url: url },
                error: bodyStringify.error,
            });
        }
        requestBody = bodyStringify.text;
    }
    var requestinit = {
        // mode: 'no-cors', // dev note: do not do this either for debugging! the Content-Type is applied to text automatically! Use a plug in instead!
        method: method,
        body: requestBody,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
        },
        credentials: 'include',
    };
    var bearer = JSON.stringify({ at: settings.accessToken, rt: settings.refreshToken });
    requestinit.headers.Authorization = "Bearer " + bearer;
    return fetch(url, requestinit)
        .then(function (response) {
        networkStatus = response.status;
        if (response.status > 299) {
            return response.text()
                .then(function (responseText) {
                var parseResponse = jsonParse(responseText);
                var responseBody = parseResponse.data;
                var serverSideError = responseBody && responseBody.error;
                if (serverSideError) {
                    return Promise.reject(__assign({ code: 1911141109 }, serverSideError, { networkStatus: networkStatus, data: __assign({}, responseBody.data, responseBody.error.data, { auth: responseBody.auth }) }));
                }
                return response.text()
                    .then(function (responseText) {
                    return Promise.reject({
                        code: 600404,
                        data: jsonParse(responseText).data || responseText,
                        networkStatus: networkStatus,
                        section: 'client/fetch',
                        message: 'server error :(',
                    });
                });
            });
        }
        return Promise.resolve(response);
    })
        .then(function (response) {
        return response.text()
            .then(function (responseText) {
            var parseResult = jsonParse(responseText);
            if (parseResult.error) {
                return Promise.reject({
                    code: 1710131735,
                    networkStatus: networkStatus,
                    section: 'client/fetch/processingResponse',
                    message: "bad server response (broken api?)",
                    data: { url: url },
                    error: parseResult.error
                });
            }
            return Promise.resolve(parseResult.data);
        });
    })
        .catch(function (error) {
        if (error.code && error.networkStatus) {
            return Promise.reject(error);
        }
        return Promise.reject({
            code: 600405,
            section: 'client/fetch',
            errorType: dyna_interfaces_1.EErrorType.HW,
            message: 'client network error :(',
            data: { url: url },
            error: error
        });
    });
};
var jsonStringify = function (data) {
    try {
        return { text: JSON.stringify(data), error: null };
    }
    catch (error) {
        return {
            text: null,
            error: {
                code: 1910131642,
                section: 'client/fetch/jsonStringify',
                message: 'cannot stringify data',
                data: { data: data },
                error: error
            }
        };
    }
};
var jsonParse = function (text) {
    try {
        return { data: JSON.parse(text), error: null };
    }
    catch (error) {
        return {
            data: null,
            error: {
                code: 1910131643,
                section: 'client/fetch/jsonParse',
                message: 'cannot parse data',
                data: { text: text },
                error: error
            }
        };
    }
};


/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = require("eventemitter3");

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = require("isomorphic-fetch");

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = require("jsonwebtoken");

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1);


/***/ })
/******/ ]);
});